import { z } from "zod";

export const createAnalyticVehiclesRequestPayloadSchema = z.array(
  z.object({
    companyUuid: z.uuid(),
    vehicleUuid: z.uuid(),
    registrationNumber: z.string(),
    department: z.uuid().nullable(),
  }),
);

export type CreateAnalyticVehiclesRequestPayload = z.infer<
  typeof createAnalyticVehiclesRequestPayloadSchema
>;
